// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JwMz","field":"styles_field__ELhnW","fieldCol":"styles_fieldCol__3kDnG","diffCol":"styles_diffCol__1Tycg","diff":"styles_diff__nkc04"};